import { Icon20InfoCircleOutline } from '@vkontakte/icons';
import classNames from 'clsx';
import { ReactComponent as CloudRebrandingIcon } from 'img/icons/cloud_rebranding.svg';
import { ReactComponent as ExclamationAnotherIcon } from 'img/icons/exclamationAnother.svg';
import overquotaGifImage from 'img/overquota/maskot.gif';
import overquotaGifDarkImage from 'img/overquota/maskotDark.gif';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';
import styles from 'reactApp/ui/OverquotaPopup/newSplash/OverquotaSplash.css';
import type { ModeType } from 'reactApp/ui/OverquotaPopup/newSplash/OverquotaSplash.types';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

export const Icon: React.FC<{ mode?: ModeType; storage: EStorageType; isMobile?: boolean }> = memo(({ mode, storage, isMobile }) => {
    const { isSubscription, isQuotaCleaner, isQuotaPartner, isQuotaTariffs } = getStorage(storage);
    const isDarkTheme = useSelector(isCurrentDarkTheme);
    const isDark = isSubscription || isQuotaCleaner || isQuotaPartner || isQuotaTariffs ? isDarkThemeModeEnabled() : isDarkTheme;

    if (mode === 'cleared') {
        return <Icon20InfoCircleOutline className={styles.iconInfo} width={38} height={38} />;
    }

    if (mode === 'after_clear' && !isMobile) {
        const img = isDark ? overquotaGifDarkImage : overquotaGifImage;

        return <img className={styles.iconNoMargin} src={img} alt="Ваши файлы были удалены" width={isMobile ? '100%' : '480'} />;
    }

    return (
        <div className={classNames(styles.icon, styles.iconRenranding)}>
            <CloudRebrandingIcon width={141} height={141} />
            <div className={styles.iconExclClear}>
                <ExclamationAnotherIcon width={7} height={33} />
            </div>
        </div>
    );
});

Icon.displayName = 'Icon';
